"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.arrayEquals = void 0;
exports.hasAny = hasAny;
exports.hasAll = hasAll;
exports.arrayEqualsIgnoreOrder = arrayEqualsIgnoreOrder;
exports.idsEqual = idsEqual;
const _ = require("lodash");
/**
 * Checks if array1 has any value in array2
 * @param array1
 * @param array2
 * @returns
 */
function hasAny(array1, array2) {
    return array1.some(value => array2.includes(value));
}
/**
 * Checks if array1 has all values in array2
 * @param array1
 * @param array2
 * @returns
 */
function hasAll(array1, array2) {
    return array2.every(value => array1.includes(value));
}
/**
 * @deprecated Use arrayEqualsIgnoreOrder as it has a clearer name
 * @param array1
 * @param array2
 * @returns
 */
const arrayEquals = (array1, array2) => arrayEqualsIgnoreOrder(array1, array2);
exports.arrayEquals = arrayEquals;
/**
 * Checks for deep equality between the elements of two arrays ignoring the order of the elements
 * @param array1
 * @param array2
 * @returns
 */
function arrayEqualsIgnoreOrder(array1, array2) {
    return array1.length === array2.length && _(array1).differenceWith(array2, _.isEqual).isEmpty();
}
function idsEqual(prev, curr) {
    const prevIds = prev.map(p => p.id);
    const currIds = curr.map(c => c.id);
    return arrayEqualsIgnoreOrder(prevIds, currIds);
}
